import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Tabs, Alert, DatePicker, Col, Row, Tooltip } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import '../css/form.css';
import EditableTable from '../components/EditableTable';
import { entriesColumns } from '../utils/tableMockData';
import { MdPublish } from "react-icons/md";
import { BiReset } from "react-icons/bi";
import { FaCloudArrowUp } from "react-icons/fa6";
import EventEmitter from '../utils/eventEmitter';
import dayjs from 'dayjs';
import { Badge } from 'flowbite-react';
import useCustomerInvoiceAPI from '../apis/customerInvoiceAPI';
import useVendorBills from '../apis/vendorBillAPI';
import CreditNoteModal from '../modals/CreditNoteModal';
import useDebitNotes from '../apis/debitNoteAPI';
import InvoiceTable from '../components/InvoiceTable';
import EntryTable from '../components/EntryTable';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// dayjs.extend(customParseFormat);

export const invoiceColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Account',
    dataIndex: 'account_id',
    key: 'account',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Analytics',
    dataIndex: 'analytics',
    key: 'analytics',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '10%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '10%'
  },
  {
    title: 'Taxes',
    dataIndex: 'taxes',
    key: 'taxes',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '15%'
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    key: 'subtotal',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    width: '10%'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  },
];


const VendorDebitNoteChanges = () => {
  const { journals, accounts, taxes, analytics, entry, bill, contacts } = useLoaderData();
  bill['bill_date'] = bill.bill_date ? dayjs(bill['bill_date'], 'YYYY-MM-DD') : '';
  bill['due_date'] = bill.due_date ? dayjs(bill['due_date'], 'YYYY-MM-DD') : '';
  bill['accounting_date'] = bill.accounting_date ? dayjs(bill['accounting_date'], 'YYYY-MM-DD') : '';
  console.log(bill)
  const [invoiceLines, setInvoiceLines] = useState(bill.line_items ? bill.line_items : []);
  const [journalEntries, setJournalEntries] = useState(entry.transactions ? entry.transactions : []);
  const [formValue, setFormValue] = useState(bill.status ? {status: bill.status} :{status: 'null'});
  const [form] = Form.useForm();
  const [tax, setTax] = useState([]);
  const { success, error } = useOutletContext();
  const params = useParams();
  const [alert, setAlert] = useState({message: '', status: ''});
  const navigate = useNavigate();
  const { save, postDebitNote } = useDebitNotes();
  const [journalDefaultAccount, setJournalDefaultAccount] = useState({});

  const onChangeJournal = opt => {
    setJournalDefaultAccount(opt);
  }

  const handleCreate = () => {
    let data = {...form.getFieldsValue()};
    data['bill_date'] = new Date(dayjs(data.bill_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['accounting_date'] = new Date(data['accounting_date']).toLocaleDateString();
    data['line_items'] = invoiceLines;
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    const journalEntry = {
      reference: data.bill_reference,
      accounting_date: data.accounting_date,
      journal_code: journal_code,
      journal_id: data.journal_id,
      transactions: [...journalEntries],
    };
    save({bill: data, entry: journalEntry}, success);
  }

  const handleConfirm = () => {
    let data = {...form.getFieldsValue()};
    data['bill_date'] = new Date(dayjs(data.bill_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['accounting_date'] = new Date(data['accounting_date']).toLocaleDateString();
    data['line_items'] = invoiceLines;
    data['status'] = 'posted';
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    const journalEntry = {
      reference: data.bill_reference,
      accounting_date: data.accounting_date,
      journal_code: journal_code,
      journal_id: data.journal_id,
      transactions: [...journalEntries],
      status: 'posted'
    };
    // let analyticItems = [];
    // invoiceLines.forEach(entryLine => {
    //   if (entryLine.analytics) {
    //     entryLine.analytics.forEach(analyticId => {
    //       let itemObject = {
    //         description: data.bill_reference, 
    //         analytic_account_id: analyticId,
    //         date: data.bill_date,
    //         amount: entryLine.subtotal,
    //         reference: '',
    //         quantity: entryLine.quantity,
    //         product: entryLine.product_id,
    //         journal_item_number: entry._id,
    //         account_id: entryLine.account_id
    //       };
    //       analyticItems.push(itemObject);
    //     });
    //   }
    // });
    postDebitNote(bill.number.replaceAll('/', '-'), {bill: data, entry: journalEntry,}, success);
  }

  

  useEffect(() => {
    EventEmitter.subscribe('debit_note_response', data => {
      navigate('/accounting/bills/'+data.number.replaceAll('/', '-'));
      setFormValue({...formValue, status: 'draft'});
    });

    EventEmitter.subscribe('debit_note_posted', data => {
      // navigate('/accounting/bills/'+data.number);
      setFormValue({...formValue, status: 'posted'});
    });


    return () => {
      EventEmitter.unsubscribe('debit_note_response');
      EventEmitter.unsubscribe('debit_note_posted');
    }
  }, [])



  return (
    <div className='container mx-auto' style={{ maxWidth: '1200px' }}>
      {alert.message !== '' && (
        <Alert message={alert.message} type={alert.status} closable showIcon />
      )}
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link to={'/accounting/debit-notes/'} className='whitespace-nowrap hover:underline font-medium text-sky-600 dark:text-white'>Debit Notes</Link> / {params.action}
            {bill.bill_reference && <span className='text-slate-400'>{` (${bill.bill_reference})`}</span>}
          </h3>
          <Tooltip
            title='save manually'
            placement='rightBottom'
            className='ms-1'
          >
            <Button onClick={handleCreate} type='text' htmlType='button'
              disabled={formValue.status === 'posted' || formValue.status === 'draft' ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
      </div>
      <div className='flex justify-between align-center'>
        <div>
          {formValue.status === 'draft' && <div>
            <Button htmlType='button' onClick={handleConfirm} >CONFIRM</Button> 
            <Button htmlType='button' className='mx-1'>CANCEL</Button>
          </div>}
          {formValue.status === 'posted' && <div>
            <Button htmlType='button' >SEND & PRINT</Button> 
            <Button htmlType='button' className='mx-1'>REGISTER PAYMENT</Button>
          </div>}
        </div>
        {formValue.status !== 'null' && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  formValue.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li
                className={
                  formValue.status === 'posted'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                POSTED
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-3 bg-white'>
        <Form 
          form={form}
          className='shadow p-3' 
          initialValues={bill.status ? bill : {
            auto_post: false,
            to_check: false
          }}  
          labelAlign='left'
          labelCol={{span: 10}}
          autoComplete="off"
          variant='borderless'
          // disabled={formValue.status === 'posted' ? true : false}
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item labelCol={{span: 7}} label='Vendor' name="vendor" className='font-bold mb-2 ' required >
                <Select options={contacts.map(contact => ({ value: contact._id, label: contact.name}))} className='font-normal'  placeholder='Select name here' />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Vendor Address' name="vendor_address" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' disabled={formValue.status === 'posted' ? true : false} placeholder='Enter address here'/>
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Bill Reference' name="bill_reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' disabled={formValue.status === 'draft' ? true : false} placeholder='Enter reference'/>
              </Form.Item>
            </Col>
            <Col md={{span: 11}}>
              <Form.Item labelCol={{span: 7}} label="Bill Date" name="bill_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' disabled={formValue.status === 'posted' ? true : false} />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label="Accounting Date" name="accounting_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' disabled={formValue.status === 'posted' ? true : false} />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Payment Reference' name="payment_reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' disabled={(formValue.status === 'posted' || formValue.status === 'draft') ? true : false}  />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label="Due Date" name="due_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' disabled={formValue.status === 'posted' ? true : false} />
              </Form.Item>
              <Form.Item labelCol={{span: 7}} label='Journal' name={'journal_id'} className='font-bold mb-2' required >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name, account: journal.default_account}))} onChange={(_, opt)=>onChangeJournal(opt)}  placeholder='select journal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Invoice Lines',
                children: <InvoiceTable name={'bill'} dataSource={invoiceLines} default_account={journalDefaultAccount} invoiceNumber={form.getFieldValue('payment_reference')} setInvoiceLines={setInvoiceLines} entries={journalEntries} setJournalEntries={setJournalEntries} columns={invoiceColumns} accounts={accounts} taxes={taxes} setTax={setTax} tax={tax} products={[]} analytics={analytics} status={formValue.status}/>
              },
              {
                key: '2',
                label: 'Journal Items',
                children: <EntryTable name={'journal entries'} dataSource={journalEntries} setJournalEntries={setJournalEntries} columns={entriesColumns} accounts={accounts} analytics={analytics} taxes={taxes} setTax={setTax} tax={tax} status={formValue.status}/>
              },
              {
                key: '3',
                label: 'Other Info',
                active: true,
                forceRender: true,
                children: 
                  <Form 
                    form={form}
                    initialValues={bill.status ? {auto_post: bill.auto_post, to_check: bill.to_check} : {
                      auto_post: false,
                      to_check: false
                    }}  
                    labelAlign='left'
                    labelCol={{span: 10}}
                    autoComplete="off"
                    variant='borderless'
                    disabled={formValue.status === 'posted' ? true : false}
                  >
                  <Row>
                    {/* <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">INVOICE</Badge>
                      <Form.Item labelCol={{span: 5}} label='Salesperson' name={'salesperson'} className='font-bold ms-2'>
                        <Select options={[]} style={{width: '200px'}}/>
                      </Form.Item>
                    </Col> */}
                    <Col  md={{span: 10}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">ACCOUNTING</Badge>
                      <Form.Item labelCol={{span: 7}} label='Auto-post' name={'auto_post'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                      <Form.Item labelCol={{span: 7}} label='To Check' name={'to_check'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              }
            ]}
          />
        </Form>
      </div>
      <CreditNoteModal />
    </div>
  )
}
export default VendorDebitNoteChanges;
